var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _rect6, _rect7, _path4, _path5, _path6, _path7, _rect8, _rect9, _rect10, _path8, _rect11, _rect12, _path9, _path10, _rect13, _path11, _path12, _rect14, _rect15, _path13, _g2, _g3, _rect16, _path14, _path15, _path16, _path17, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateWithAiIntermediateStep = function SvgCreateWithAiIntermediateStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 360 360"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 360,
    height: 360,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h360v360H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D6D6D6",
    filter: "url(#d)",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-48-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M136-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M159-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M182-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M205-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M228-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M251-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M274-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M297-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M320-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M343-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M366-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M389-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M412-57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-48-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M136-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M159-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M182-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M205-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M228-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M251-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M274-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M297-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M320-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M343-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M366-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M389-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M412-34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-48-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M136-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M159-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M182-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M205-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M228-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M251-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M274-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M297-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M320-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M343-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M366-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M389-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M412-11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-48 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M136 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M159 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M182 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M205 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M228 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M251 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M274 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M297 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M320 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M343 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M366 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M389 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M412 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-48 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M136 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M159 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M182 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M205 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M228 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M251 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M274 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M297 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M320 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M343 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M366 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M389 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M412 34.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-48 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M136 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M159 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M182 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M205 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M228 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M251 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M274 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M297 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M320 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M343 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M366 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M389 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M412 57.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-48 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M136 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M159 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M182 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M205 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M228 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M251 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M274 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M297 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M320 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M343 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M366 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M389 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M412 80.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-48 103.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 103.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 103.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 103.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 103.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 103.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 103.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 103.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 126.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 126.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 126.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 126.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 126.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 126.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 126.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 126.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 149.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 149.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 149.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 149.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 149.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 149.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 149.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 149.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 172.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 172.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 172.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 172.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 172.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 172.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 172.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 172.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 195.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 195.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 195.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 195.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 195.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 195.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 195.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 195.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 218.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 218.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 218.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 218.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 218.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 218.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 218.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 218.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 241.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 241.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 241.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 241.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 241.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 241.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 241.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 241.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 264.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 264.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 264.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 264.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 264.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 264.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 264.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 264.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 287.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 287.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 287.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 287.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 287.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 287.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 287.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 287.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 310.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 310.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 310.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 310.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 310.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 310.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 310.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 310.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 333.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 333.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 333.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 333.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 333.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 333.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 333.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 333.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 356.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 356.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 356.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 356.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 356.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 356.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 356.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 356.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 379.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 379.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 379.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 379.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 379.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 379.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 379.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 379.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M-48 402.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-25 402.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M-2 402.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 402.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M44 402.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M67 402.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M90 402.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M113 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M136 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M159 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M182 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M205 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M228 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M251 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M274 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M297 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M320 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M343 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M366 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M389 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001M412 402.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148.5,
    height: 148.5,
    x: 105.75,
    y: 60.75,
    fill: "#FAFAFA",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    rx: 15.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    x: 261.5,
    y: 60.5,
    stroke: "url(#e)",
    rx: 15.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    x: -50.5,
    y: 60.5,
    stroke: "url(#f)",
    rx: 15.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    x: -50.5,
    y: -95.5,
    stroke: "url(#g)",
    rx: 15.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 149,
    x: 105.5,
    y: -95.5,
    stroke: "url(#h)",
    rx: 15.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillOpacity: 0.5,
    stroke: "#D6D6D6",
    d: "M117.5 80a7.5 7.5 0 0 1 7.5-7.5h110a7.5 7.5 0 0 1 7.5 7.5v22a7.5 7.5 0 0 1-7.5 7.5H125a7.5 7.5 0 0 1-7.5-7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.998,
    d: "M139.667 85.999c0 .31 0 .464-.026.593a1.33 1.33 0 0 1-1.047 1.048c-.129.025-.284.025-.594.025h-7.333c-.31 0-.465 0-.594-.025a1.33 1.33 0 0 1-1.047-1.048C129 86.463 129 86.308 129 86c0-.31 0-.465.026-.594a1.33 1.33 0 0 1 1.047-1.047c.129-.026.284-.026.594-.026H138c.31 0 .465 0 .594.026.529.105.942.518 1.047 1.047.026.129.026.284.026.594m0 0c.621 0 .932 0 1.177.101.327.136.586.395.721.722.102.245.102.555.102 1.177v.2c0 .746 0 1.12-.145 1.405-.128.25-.332.455-.583.583-.285.145-.659.145-1.405.145h-2.4c-.747 0-1.121 0-1.406.145a1.33 1.33 0 0 0-.582.583c-.146.285-.146.659-.146 1.405V93m-.266 4.666h.533c.373 0 .56 0 .703-.072a.67.67 0 0 0 .291-.292c.073-.142.073-.329.073-.702v-2.534c0-.373 0-.56-.073-.702a.67.67 0 0 0-.291-.292c-.143-.072-.33-.072-.703-.072h-.533c-.374 0-.56 0-.703.072a.66.66 0 0 0-.291.292c-.073.142-.073.329-.073.702V96.6c0 .373 0 .56.073.702a.66.66 0 0 0 .291.292c.143.072.329.072.703.072"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 4,
    x: 150,
    y: 94,
    fill: "url(#i)",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 6,
    x: 150,
    y: 84,
    fill: "#BEBEBE",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillOpacity: 0.5,
    stroke: "#E5E5E5",
    d: "M117.5 80a7.5 7.5 0 0 1 7.5-7.5h110a7.5 7.5 0 0 1 7.5 7.5v22a7.5 7.5 0 0 1-7.5 7.5H125a7.5 7.5 0 0 1-7.5-7.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M121 81a5 5 0 0 1 5-5h108a5 5 0 0 1 5 5v20a5 5 0 0 1-5 5H126a5 5 0 0 1-5-5z",
    "data-id": "appearance-enabled-bg"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    d: "M224 99a8 8 0 1 0 0-16 8 8 0 0 0 0 16m4.009-9.73a.804.804 0 1 0-1.163-1.11l-3.891 4.076-1.929-1.326a.804.804 0 0 0-.911 1.324l2.494 1.714a.8.8 0 0 0 1.036-.107z",
    clipRule: "evenodd",
    "data-id": "appearance-enabled-icon"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.998,
    d: "M139.667 85.999c0 .31 0 .464-.026.593a1.33 1.33 0 0 1-1.047 1.048c-.129.025-.284.025-.594.025h-7.333c-.31 0-.465 0-.594-.025a1.33 1.33 0 0 1-1.047-1.048C129 86.463 129 86.308 129 86c0-.31 0-.465.026-.594a1.33 1.33 0 0 1 1.047-1.047c.129-.026.284-.026.594-.026H138c.31 0 .465 0 .594.026.529.105.942.518 1.047 1.047.026.129.026.284.026.594m0 0c.621 0 .932 0 1.177.101.327.136.586.395.721.722.102.245.102.555.102 1.177v.2c0 .746 0 1.12-.145 1.405-.128.25-.332.455-.583.583-.285.145-.659.145-1.405.145h-2.4c-.747 0-1.121 0-1.406.145a1.33 1.33 0 0 0-.582.583c-.146.285-.146.659-.146 1.405V93m-.266 4.666h.533c.373 0 .56 0 .703-.072a.67.67 0 0 0 .291-.292c.073-.142.073-.329.073-.702v-2.534c0-.373 0-.56-.073-.702a.67.67 0 0 0-.291-.292c-.143-.072-.33-.072-.703-.072h-.533c-.374 0-.56 0-.703.072a.66.66 0 0 0-.291.292c-.073.142-.073.329-.073.702V96.6c0 .373 0 .56.073.702a.66.66 0 0 0 .291.292c.143.072.329.072.703.072"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 4,
    x: 150,
    y: 94,
    fill: "url(#k)",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 6,
    x: 150,
    y: 84,
    fill: "#BEBEBE",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 37,
    x: 117.5,
    y: 116.5,
    fill: "#E5E5E5",
    fillOpacity: 0.5,
    stroke: "#D6D6D6",
    rx: 7.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M121 125a5 5 0 0 1 5-5h108a5 5 0 0 1 5 5v20a5 5 0 0 1-5 5H126a5 5 0 0 1-5-5z",
    "data-id": "page-type-enabled-bg"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 4,
    x: 150,
    y: 138,
    fill: "url(#l)",
    rx: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 6,
    x: 150,
    y: 128,
    fill: "#BEBEBE",
    rx: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3A3",
    d: "m132.123 141.375.226-.445zm-1.166-1.166.445-.226zm10.086 0-.445-.226zm-1.166 1.166-.226-.445zm-2.497-12.861.13-.482zm3.772 3.771.481-.129zm-8.509-3.862-.129-.482zm-1.885 1.886-.482-.13zm10.575 4.387h-.498zm-6.363-6.364v.499zm4.242 4.242v.499zm1.385.141.223-.446zm.595.596.446-.223zm-4.101-2.858h-.499zm.141 1.385-.446.223zm.596.595-.224.446zm-.878-3.364.446-.224zm-.596-.596.224-.446zm-1.276 6.435-.243-.436zm.083-.051-.312-.389zm.093-.127.44.236zm-.049.082-.392-.308zm-.808 1.232-.243.435zm-.372-.268-.453.21zm.372-.489.242.436zm-.372.267-.453-.209zm1.229 1.047-.439.236zm-.049-.082-.392.308zm-.127-.096.242-.436zm.083.051.312-.389zm1.245.76.439.236zm-.285.406-.204-.455zm-.527-.406.44-.236zm.285.406.204-.455zm1.044-1.217-.243-.436zm-.084.051-.312-.389zm-.093.127-.439-.236zm.049-.082.392.308zm.808-1.232-.242.436zm.373.267.452-.209zm-.373.49.243.435zm.373-.268.452.21zm-1.23-1.046.439-.236zm.049.082.392-.308zm.128.096.242-.436zm-.084-.051.313-.389zm-.433-.76-.439.236zm-.285-.406-.204.455zm-.527.406.44.236zm.285-.406.204.455zm-2.546 4.142a.499.499 0 0 0 0 .998zm.034.998a.499.499 0 0 0 0-.998zm7.468-3.388v1.956h.997v-1.956zm-3.768 5.724h-2.134v.997h2.134zm-5.902-3.768v-5.511h-.997v5.511zm3.768 3.768c-.755 0-1.291-.001-1.71-.035-.414-.034-.671-.098-.874-.202l-.453.889c.368.187.77.268 1.245.307.47.039 1.054.038 1.792.038zm-4.765-3.768c0 .738 0 1.322.038 1.792.039.475.12.878.307 1.245l.889-.453c-.104-.203-.168-.46-.202-.873-.034-.42-.035-.956-.035-1.711zm2.181 3.531a2.17 2.17 0 0 1-.947-.947l-.889.453c.303.595.788 1.08 1.383 1.383zm8.486-3.531c0 .755-.001 1.291-.035 1.711-.034.413-.098.67-.202.873l.889.453c.187-.367.268-.77.307-1.245.039-.47.038-1.054.038-1.792zm-3.768 4.765c.738 0 1.322.001 1.792-.038.475-.039.878-.12 1.245-.307l-.453-.889c-.203.104-.46.168-.873.202-.42.034-.956.035-1.711.035zm3.531-2.181a2.16 2.16 0 0 1-.947.947l.453.889a3.17 3.17 0 0 0 1.383-1.383zm-6.376-11.152c1.686 0 2.431.004 3.029.165l.259-.964c-.758-.203-1.667-.199-3.288-.199zm7.61 6.612c0-1.621.004-2.529-.199-3.287l-.963.258c.16.599.165 1.344.165 3.029zm-4.581-6.447a4.83 4.83 0 0 1 3.419 3.418l.963-.258a5.83 5.83 0 0 0-4.123-4.124zm-3.029-1.163c-.794 0-1.289-.004-1.708.108l.258.964c.26-.07.592-.074 1.45-.074zm-3.057 4.055c0-.859.005-1.191.074-1.45l-.963-.259c-.112.419-.108.914-.108 1.709zm1.349-3.947a3.17 3.17 0 0 0-2.238 2.238l.963.259a2.17 2.17 0 0 1 1.533-1.533zm8.321 6.755v.303h.997v-.303zm-5.865-6.863h-.303v.998h.303zm4.242 5.24c.376 0 .628.001.823.016a.9.9 0 0 1 .339.072l.446-.892a1.9 1.9 0 0 0-.705-.174c-.244-.02-.543-.019-.903-.019zm2.62 1.623c0-.36.001-.659-.019-.903a1.9 1.9 0 0 0-.175-.705l-.892.446c.03.06.057.151.073.339.015.195.016.447.016.823zm-1.458-1.535a.83.83 0 0 1 .372.373l.892-.446a1.84 1.84 0 0 0-.818-.819zm-3.782-2.708c0 .36 0 .659.019.903.021.249.064.483.175.705l.892-.446c-.03-.06-.057-.151-.072-.339-.016-.195-.016-.447-.016-.823zm2.62 1.623c-.376 0-.628-.001-.822-.016-.189-.016-.279-.043-.339-.073l-.447.892c.222.112.456.155.706.175.243.02.543.019.902.019zm-2.426-.015c.177.354.464.641.818.818l.447-.892a.83.83 0 0 1-.373-.372zm.804-1.608c0-.359 0-.659-.019-.902a1.9 1.9 0 0 0-.175-.706l-.892.447c.03.06.057.15.072.339.016.194.016.446.016.822zm-2.62-1.622c.376 0 .628 0 .822.016.189.015.279.042.339.072l.447-.892a1.9 1.9 0 0 0-.706-.174c-.243-.02-.543-.02-.902-.02zm2.426.014a1.83 1.83 0 0 0-.818-.818l-.447.892a.84.84 0 0 1 .373.373zm-1.429 5.488.34.633.878-.472-.34-.633zm.713 1.011.681.379.485-.872-.681-.379zm.681.264-.681.379.485.871.681-.379zm-1.054.757-.34.633.878.472.34-.633zm-.273.633-.34-.633-.879.472.34.633zm-.714-1.011-.681-.379-.485.871.681.379zm-.681-.264.681-.379-.485-.872-.681.379zm1.055-.757.34-.633-.879-.472-.34.633zm-.374.378c.029-.016.094-.05.153-.098l-.624-.778.017-.013.005-.003-.01.006-.026.014zm-.505-.85-.014.025-.005.01.004-.007.013-.018.784.617c.048-.061.082-.127.097-.155zm.658.752a.8.8 0 0 0 .124-.125l-.784-.617a.2.2 0 0 1 .036-.036zm-.834.362-.139-.079a1 1 0 0 1-.078-.048c-.016-.01-.013-.01-.003 0a.3.3 0 0 1 .058.086l-.905.419a.8.8 0 0 0 .288.32c.084.057.191.116.294.173zm-.485-.757c-.103.058-.21.117-.294.174a.8.8 0 0 0-.288.32l.905.419a.3.3 0 0 1-.058.085c-.01.011-.013.011.003 0q.021-.014.078-.047l.139-.079zm.323.716a.23.23 0 0 1 0 .197l-.905-.419a.76.76 0 0 0 0 .641zm1.217.798c-.015-.028-.049-.094-.097-.155l-.784.617-.013-.018-.004-.007.005.01.014.025zm-.859.493.026.015.01.006-.005-.004-.017-.012.624-.778c-.059-.048-.124-.082-.153-.098zm.762-.648a.7.7 0 0 0-.124-.125l-.624.778a.3.3 0 0 1-.036-.036zm.37.788-.084.153a1 1 0 0 1-.051.087c-.012.018-.013.016-.002.005a.3.3 0 0 1 .087-.058l.408.91a.8.8 0 0 0 .338-.306c.06-.09.122-.206.182-.319zm-.812.472c.061.113.122.229.182.319a.8.8 0 0 0 .338.306l.408-.91c.047.02.075.046.087.058.011.011.01.013-.002-.005q-.017-.025-.051-.087-.035-.062-.083-.153zm.762-.285a.2.2 0 0 1 .166 0l-.408.91a.8.8 0 0 0 .65 0zm.763-1.198c-.029.016-.094.05-.153.098l.625.778-.018.012-.005.004.011-.006.025-.015zm.505.85.014-.025.005-.01-.004.007-.013.018-.784-.617a1 1 0 0 0-.096.155zm-.658-.752a.8.8 0 0 0-.124.125l.784.617a.3.3 0 0 1-.035.036zm.834-.362.217.126c.016.011.014.011.003 0a.3.3 0 0 1-.058-.085l.905-.419a.8.8 0 0 0-.288-.32c-.084-.057-.191-.116-.294-.174zm.485.756c.103-.057.21-.116.294-.173a.8.8 0 0 0 .288-.32l-.905-.419a.3.3 0 0 1 .058-.086c.011-.01.013-.01-.003 0a12.149 12.149 0 0 1-.217.127zm-.323-.715a.23.23 0 0 1 0-.197l.905.419a.76.76 0 0 0 0-.641zm-1.216-.798a1 1 0 0 0 .096.155l.784-.617.013.018.004.007-.005-.01-.014-.025zm.858-.494-.025-.014-.011-.006.005.003.018.013-.625.778c.059.048.124.082.153.098zm-.762.649a1 1 0 0 0 .124.125l.625-.778a.2.2 0 0 1 .035.036zm.442-1.26a4 4 0 0 0-.182-.319.8.8 0 0 0-.338-.306l-.408.91a.3.3 0 0 1-.087-.058c-.011-.011-.01-.013.002.005q.017.025.051.087l.084.153zm-.811.472q.048-.091.083-.153.035-.061.051-.087c.012-.018.013-.016.002-.005a.3.3 0 0 1-.087.058l-.408-.91a.8.8 0 0 0-.338.306c-.06.09-.121.206-.182.319zm.291-1.097a.8.8 0 0 0-.65 0l.408.91a.2.2 0 0 1-.166 0zm-2.992 5.595h.034v-.998h-.034z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    fillRule: "evenodd",
    d: "M224 143a8 8 0 1 0 0-16 8 8 0 0 0 0 16m4.009-9.73a.805.805 0 0 0-1.163-1.11l-3.891 4.076-1.929-1.326a.804.804 0 1 0-.911 1.324l2.494 1.714a.8.8 0 0 0 1.036-.107z",
    clipRule: "evenodd",
    "data-id": "page-type-enabled-icon"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 37,
    x: 117.5,
    y: 160.5,
    fill: "#E5E5E5",
    fillOpacity: 0.5,
    stroke: "#E5E5E5",
    rx: 7.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M121 169a5 5 0 0 1 5-5h108a5 5 0 0 1 5 5v20a5 5 0 0 1-5 5H126a5 5 0 0 1-5-5z",
    "data-id": "source-enabled-bg"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    fillRule: "evenodd",
    d: "M224 187a8 8 0 1 0 0-16 8 8 0 0 0 0 16m4.009-9.73a.805.805 0 0 0-1.163-1.11l-3.891 4.076-1.929-1.326a.804.804 0 1 0-.911 1.324l2.494 1.714a.8.8 0 0 0 1.036-.107z",
    clipRule: "evenodd",
    "data-id": "source-enabled-icon"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 4,
    x: 150,
    y: 182,
    fill: "url(#o)",
    rx: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 6,
    x: 150,
    y: 172,
    fill: "#BEBEBE",
    rx: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.998,
    d: "m135.666 175.667-.743-1.488c-.214-.428-.321-.642-.481-.798a1.3 1.3 0 0 0-.498-.308c-.212-.073-.451-.073-.929-.073h-2.549c-.746 0-1.12 0-1.405.145a1.34 1.34 0 0 0-.583.583c-.145.285-.145.659-.145 1.405v.534m0 0h10.133c1.12 0 1.68 0 2.108.218.377.191.683.497.874.874.218.428.218.988.218 2.108v2.933c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218h-6.933c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108zm6.667 6.666v-4m-2 2h4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#D6D6D6",
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m198.632 247.093.651 1.731c.156.414.234.621.355.795q.162.233.39.399c.171.124.373.204.779.363l1.693.666-1.693.665c-.406.16-.608.239-.779.363a1.7 1.7 0 0 0-.39.399c-.121.174-.199.381-.355.795l-.651 1.731-.652-1.731c-.156-.414-.234-.621-.355-.795a1.7 1.7 0 0 0-.39-.399c-.171-.124-.373-.203-.778-.363l-1.694-.665 1.694-.666c.405-.159.607-.239.778-.363q.228-.166.39-.399c.121-.174.199-.381.355-.795zM193.382 246l.24.492c.082.167.123.25.177.322a1 1 0 0 0 .167.171c.071.056.152.097.315.181l.482.246-.482.246a2 2 0 0 0-.315.181 1 1 0 0 0-.167.17 2 2 0 0 0-.177.323l-.24.492-.241-.492a2 2 0 0 0-.177-.323 1 1 0 0 0-.167-.17 2 2 0 0 0-.315-.181l-.482-.246.482-.246c.163-.084.244-.125.315-.181a1 1 0 0 0 .167-.171c.054-.072.095-.155.177-.322z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "m181.572 265.5-4.824-12.6h2.466l4.968 12.6zm-9.954 0 4.968-12.6h2.466l-4.824 12.6zm2.34-2.772v-2.178h7.902v2.178zm11.733 2.772v-12.6h2.466v12.6z"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 59,
    x: 106.5,
    y: 216.5,
    fill: "#F5F5F5",
    stroke: "#D6D6D6",
    strokeWidth: 3,
    rx: 16.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.5 233c0-8.56 6.94-15.5 15.5-15.5h114c8.56 0 15.5 6.94 15.5 15.5v26c0 8.56-6.94 15.5-15.5 15.5H123c-8.56 0-15.5-6.94-15.5-15.5z",
    "data-id": "create-with-ai-enabled-bg-1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M107.5 233c0-8.56 6.94-15.5 15.5-15.5h114c8.56 0 15.5 6.94 15.5 15.5v26c0 8.56-6.94 15.5-15.5 15.5H123c-8.56 0-15.5-6.94-15.5-15.5z",
    "data-id": "create-with-ai-enabled-bg-2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M107.5 233c0-8.56 6.94-15.5 15.5-15.5h114c8.56 0 15.5 6.94 15.5 15.5v26c0 8.56-6.94 15.5-15.5 15.5H123c-8.56 0-15.5-6.94-15.5-15.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m205.842 228.458.869 2.307c.207.552.311.828.473 1.061q.217.31.52.532c.228.165.498.271 1.038.483l2.258.888-2.258.887c-.54.213-.81.319-1.038.484a2.2 2.2 0 0 0-.52.532c-.162.232-.266.508-.473 1.06l-.869 2.308-.868-2.308c-.208-.552-.312-.828-.474-1.06a2.2 2.2 0 0 0-.52-.532c-.227-.165-.498-.271-1.038-.484l-2.258-.887 2.258-.888c.54-.212.811-.318 1.038-.483.201-.147.377-.327.52-.532.162-.233.266-.509.474-1.061zM198.842 227l.321.656c.109.222.163.334.236.43q.096.128.223.228c.094.074.203.129.42.24l.642.329-.642.328c-.217.111-.326.166-.42.241a1.2 1.2 0 0 0-.223.227c-.073.097-.127.208-.236.43l-.321.656-.321-.656c-.109-.222-.163-.333-.236-.43a1.2 1.2 0 0 0-.223-.227c-.094-.075-.202-.13-.42-.241l-.642-.328.642-.329c.218-.111.326-.166.42-.24q.127-.1.223-.228c.073-.096.127-.208.236-.43zM155.158 263.542l-.869-2.307c-.207-.552-.311-.828-.473-1.061a2.3 2.3 0 0 0-.52-.532c-.228-.165-.498-.271-1.038-.483l-2.258-.888 2.258-.887c.54-.213.81-.319 1.038-.484.201-.146.377-.326.52-.532.162-.232.266-.508.473-1.06l.869-2.308.868 2.308c.208.552.312.828.474 1.06.143.206.319.386.52.532.227.165.498.271 1.038.484l2.258.887-2.258.888c-.54.212-.811.318-1.038.483a2.3 2.3 0 0 0-.52.532c-.162.233-.266.509-.474 1.061zM162.158 265l-.321-.656c-.109-.222-.163-.334-.236-.43a1.2 1.2 0 0 0-.223-.228c-.094-.074-.203-.129-.42-.24l-.642-.329.642-.328c.217-.111.326-.166.42-.241q.126-.098.223-.227c.073-.097.127-.208.236-.43l.321-.656.321.656c.109.222.163.333.236.43q.096.129.223.227c.094.075.202.13.42.241l.642.328-.642.329c-.218.111-.326.166-.42.24a1.2 1.2 0 0 0-.223.228c-.073.096-.127.208-.236.43zM181.929 254l-6.432-16.8h3.288l6.624 16.8zm-13.272 0 6.624-16.8h3.288l-6.432 16.8zm3.12-3.696V247.4h10.536v2.904zM187.422 254v-16.8h3.288V254z",
    "data-id": "create-with-ai-text"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#t)",
    d: "M241.4 234h20.486c4.167 0 8.173-1.613 11.178-4.5a16.14 16.14 0 0 1 11.179-4.5h76.007",
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#v)",
    d: "M255 246.75h41.111c9.239 0 16.978-6.995 17.909-16.186l8.722-86.127c.93-9.192 8.669-16.187 17.908-16.187h18.975",
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#x)",
    d: "M255 246.75h41.111c9.239 0 16.978 6.995 17.909 16.186l8.722 86.127c.93 9.192 8.669 16.187 17.908 16.187h18.975",
    shapeRendering: "crispEdges"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#z)",
    d: "M241.4 258h20.486c4.167 0 8.173 1.613 11.178 4.5a16.14 16.14 0 0 0 11.179 4.5h76.007",
    shapeRendering: "crispEdges"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#B)",
    d: "M118.625 233.75H98.739a16.14 16.14 0 0 1-11.178-4.5 16.14 16.14 0 0 0-11.179-4.5H.375",
    shapeRendering: "crispEdges"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#D)",
    d: "M104.625 246.5H63.514c-9.24 0-16.978-6.995-17.909-16.186l-8.721-86.127C35.953 134.995 28.213 128 18.975 128H0",
    shapeRendering: "crispEdges"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#F)",
    d: "M104.625 246.5H63.514c-9.24 0-16.978 6.995-17.909 16.186l-8.721 86.127C35.953 358.005 28.213 365 18.975 365H0",
    shapeRendering: "crispEdges"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#H)",
    d: "M118.625 258.25H98.739a16.14 16.14 0 0 0-11.178 4.5 16.14 16.14 0 0 1-11.179 4.5H.375",
    shapeRendering: "crispEdges"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 234,
    r: 4.75,
    fill: "#E5E5E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 234,
    r: 4.75,
    stroke: "url(#I)",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 234,
    r: 4.75,
    fill: "#E5E5E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 234,
    r: 4.75,
    stroke: "url(#J)",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 258,
    r: 4.75,
    fill: "#E5E5E5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 258,
    r: 4.75,
    stroke: "url(#K)",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 258,
    r: 4.75,
    fill: "#E5E5E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 258,
    r: 4.75,
    stroke: "url(#L)",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 359.625,
    x2: 261,
    y1: 135,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.375,
    x2: 99,
    y1: 135,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 76.125,
    x2: 93.75,
    y1: 14.625,
    y2: 47.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 212.929,
    x2: 206.091,
    y1: 24,
    y2: 53.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 150,
    x2: 204,
    y1: 96,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 224,
    x2: 224,
    y1: 83,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA51C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 150,
    x2: 204,
    y1: 96,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 150,
    x2: 204,
    y1: 140,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 224,
    x2: 224,
    y1: 127,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA51C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 224,
    x2: 224,
    y1: 171,
    y2: 187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA51C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 150,
    x2: 204,
    y1: 184,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 180,
    x2: 180,
    y1: 217,
    y2: 275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA51C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 354.5,
    x2: 241,
    y1: 229.5,
    y2: 229.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 330.75,
    x2: 255,
    y1: 165.75,
    y2: 242.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 330.75,
    x2: 255,
    y1: 327.75,
    y2: 251.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 354.5,
    x2: 241,
    y1: 262.5,
    y2: 262.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 7.5,
    x2: 119.625,
    y1: 229.25,
    y2: 229.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 28.875,
    x2: 104.625,
    y1: 165.5,
    y2: 242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 28.875,
    x2: 104.625,
    y1: 327.5,
    y2: 251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 7.5,
    x2: 119.625,
    y1: 262.75,
    y2: 262.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 240,
    x2: 232,
    y1: 234,
    y2: 234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 128,
    x2: 120,
    y1: 234,
    y2: 234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 240,
    x2: 232,
    y1: 258,
    y2: 258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 128,
    x2: 120,
    y1: 258,
    y2: 258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 463,
    height: 464,
    x: -51,
    y: -59,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    width: 10.5,
    height: 9.75,
    x: 192,
    y: 246,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_5214_28335"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    width: 16.54,
    height: 13.35,
    x: 171.618,
    y: 252.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_5214_28335"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: 118.85,
    height: 10.75,
    x: 241.4,
    y: 224.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    width: 104.625,
    height: 120.25,
    x: 255,
    y: 127.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    width: 104.625,
    height: 120.25,
    x: 255,
    y: 246.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    width: 118.85,
    height: 10.75,
    x: 241.4,
    y: 257.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "A",
    width: 118.25,
    height: 10.75,
    x: 0.375,
    y: 224.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "C",
    width: 104.625,
    height: 120.25,
    x: 0,
    y: 127.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "E",
    width: 104.625,
    height: 120.25,
    x: 0,
    y: 246,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "G",
    width: 118.25,
    height: 10.75,
    x: 0.375,
    y: 257.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5214_28335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5214_28335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 81 -102.942 0 180 279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h360v360H0z"
  })))));
};
export { SvgCreateWithAiIntermediateStep as ReactComponent };
export default __webpack_public_path__ + "b82285455e470e4f9be435e33b18221c.svg";